import { combineReducers } from 'redux';
import create from './create';
import edit from './edit';
import view from './view';

export default combineReducers({
  create,
  edit,
  view
});
